import React, { useEffect, useState } from 'react'
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminBackNavigation from '../../../../components/CommonComponents/AdminBackNavigation';
import AdminSaveHeader from '../../../../components/CommonComponents/AdminSaveHeader';
import FormContainer from '../../../../components/CommonComponents/FormContainer';
import LeftWrapper from '../../../../components/CommonComponents/LeftWrapper';
import Wrapper from '../../../../components/CommonComponents/Wrapper';
import MessageSubHeading from '../../../../components/CommonComponents/MessageSubHeading';
import MessageLabel from '../../../../components/CommonComponents/MessageLabel';
import AdminImageUploadZone from '../../../../components/CommonComponents/AdminImageUploadZone';
import RightWrapper from '../../../../components/CommonComponents/RightWrapper';
import { toast } from "react-toastify"
import Response_Processing from '../../../../layout/Others/Response_Processing';
import Response_Loading_processing from '../../../../layout/Others/Response_Loading_processing';
import Defaultloadinggif from '../../../../layout/Others/Defaultloadinggif';


const Default_Image_Setting = () => {

    const { fetchRequest, globalImageUplaodAPI } = useMyContext()

    const baseURL = process.env.REACT_APP_Baseurl
    const indexApi = `${baseURL}/admin/setting/index`
    const updateApi = globalImageUplaodAPI()

    const [formData, setFormData] = useState()
    const [formDataError, setFormDataError] = useState()
    const [verticalImageFile, setVerticalImageFile] = useState(null);
    const [horizontalImageFile, setHorizontalImageFile] = useState(null);
    const [loading, setLoading] = useState(true)
    const [formValid, setFormValid] = useState(true)

    const fetchData = async () => {
        setLoading(true)
        try {
            const response = await fetchRequest({ method: 'GET', url: indexApi })

            if (response?.status) {
                toast.success('Retrieved Default images Successfully')
                const data = { id: response?.setting?.id, default_video_image: response?.setting?.default_video_image, default_horizontal_image: response?.setting?.default_horizontal_image }
                setFormData(data)
            }
        } catch (error) {
            toast.error(`${error.response.message || 'Update failed'}`)
        } finally {
            setLoading(false)
        }
    }

    async function handleUpdate() {
        if (formValid) {
            setLoading(true);
            try {
                const formDataAdd = new FormData();

                formDataAdd.append('modelName', 'Setting')
                formDataAdd.append('id', formData?.id)
                const imageFields = [];

                if (verticalImageFile) {
                    formDataAdd.append('default_video_image', verticalImageFile);
                    imageFields.push('default_video_image');
                }
                if (horizontalImageFile) {
                    formDataAdd.append('default_horizontal_image', horizontalImageFile);
                    imageFields.push('default_horizontal_image');
                }

                imageFields.forEach(f => formDataAdd.append('imageFields[]', f));
                const response = await fetchRequest({
                    method: 'POST',
                    url: updateApi,
                    data: formDataAdd,
                });
                if (response?.status) {
                    toast.success("Default image Updated Successfully")
                    const data = { default_video_image: response?.data?.default_video_image ?? formData?.default_video_image, default_horizontal_image: response?.data?.default_horizontal_image ?? formData?.default_horizontal_image }

                    setFormData(prev => ({
                        ...prev,
                        ...data
                    }))
                    setVerticalImageFile(null)
                    setHorizontalImageFile(null)
                }
            } catch (error) {
                console.error(error?.response?.message)
            } finally {
                setLoading(false)
            }
        }
    }

    const handleFileChange = (event) => {
        const { files, name } = event.target;
        console.log(`name ${name}`);

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        if (!files || files.length === 0) return;
        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            const msg = "Only WEBP, PNG, JPG, or JPEG image files are allowed.";
            setFormDataError((prev) => ({ ...prev, [name]: msg }))
            return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            const width = img.width;
            const height = img.height;
            const ratio = width / height;
            const within = (actual, expected, tol = 0.01) => Math.abs(actual - expected) <= tol;

            if (name === 'default_video_image') {
                const valid = within(ratio, 2 / 3) || (width === 1080 && height === 1620);
                if (!valid) {
                    setFormDataError((prev) => ({ ...prev, [name]: "Image must be 1080x1620 or 2:3 ratio." }))
                    setVerticalImageFile(file)
                    setFormValid(false)
                } else {
                    setFormDataError((prev) => ({ ...prev, [name]: "" }))
                    setVerticalImageFile(file)
                    setFormValid(true)
                }
            } else {
                const valid = within(ratio, 16 / 9) || (width === 1280 && height === 720);
                if (!valid) {
                    setFormDataError((prev) => ({ ...prev, [name]: "Image must be 1280x720 or 16:9 ratio." }))
                    setHorizontalImageFile(file)
                    setFormValid(false)
                } else {
                    setFormDataError((prev) => ({ ...prev, [name]: "" }))
                    setHorizontalImageFile(file)
                    setFormValid(true)
                }
            }
        };
    }

    const handleClearSelectFile = (value) => {
        if (value == 'default_video_image') {
            setVerticalImageFile(null)
            setFormValid(true)
            setFormDataError((prev) => ({ ...prev, [value]: '' }))
        }
        if (value == 'default_horizontal_image') {
            setHorizontalImageFile(null)
            setFormValid(true)
            setFormDataError((prev) => ({ ...prev, [value]: '' }))
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    if (loading) return <Defaultloadinggif className={"heightOnLoader"} />
    return (
        <>
            <AdminBackNavigation path="/settings" text="Back" />
            <AdminSaveHeader heading={'Default Image Settings'} saveText={'Update'} saveMethod={handleUpdate} loading={loading} />

            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageLabel text={'Vertical Default Image'} />
                        <MessageSubHeading text={'Select the image( 2:3 Ratio or 1080X1620px )'} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={verticalImageFile}
                            uploadedImage={formData?.default_video_image}
                            onDelete={handleClearSelectFile}
                            name="default_video_image"
                            id={formData?.id}
                            idAttribute={formData?.vertical_image}
                            error={formDataError?.default_video_image}
                        />
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageLabel text={'Horizontal Default Image'} />
                        <MessageSubHeading text={'Select the image( 16:9 Ratio or 1280X720px )'} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={horizontalImageFile}
                            uploadedImage={formData?.default_horizontal_image}
                            onDelete={handleClearSelectFile}
                            name="default_horizontal_image"
                            id={formData?.id}
                            error={formDataError?.default_horizontal_image}
                        />
                    </Wrapper>
                </RightWrapper>
            </FormContainer>

        </>
    )
}

export default Default_Image_Setting